import { render, staticRenderFns } from "./XhLeaves.vue?vue&type=template&id=18e3804d&scoped=true"
import script from "./XhLeaves.vue?vue&type=script&lang=js"
export * from "./XhLeaves.vue?vue&type=script&lang=js"
import style0 from "./XhLeaves.vue?vue&type=style&index=0&id=18e3804d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e3804d",
  null
  
)

export default component.exports